import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import ChatBotPage from './ChatBotPage';
import MapView from './MapView';
import reportWebVitals from './reportWebVitals';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { Provider } from 'jotai';
import HomePage from './website/HomePage';
import Protected from './Protected';
import { LoginPage } from './website/LoginPage';
import { SignUpPage } from './website/SignUpPage';
import './i18n.ts';
import SettingsPage from './SettingsPage';
import { PartialTheme, ThemeProvider } from '@fluentui/react/lib/Theme';
import AdministrationPage from './administration/AdministrationPage';
import LegalPage from './website/LegalPage';
import PressPage from './website/PressPage';
import MarkupPage from './MarkupPage';
import EntityPage from './EntityPage';
import TestDIN276 from './TestDIN276';
import { CustomerThemeProvider, useCustomerTheme } from './Theme';
import { registerIcons } from '@fluentui/react';
import { EndPointSolidIcon } from '@fluentui/react-icons-mdl2';
import ImprintPage from './website/ImprintPage';
import { EditorTest } from './floorplanEditor/EditorTest';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import SupportPage from './website/SupportPage';
import { ModalContextProvider } from './components/ModalProvider';
import MapAndImageView from './MapAndImageView';

// Override console.error to catch the specific error
const originalConsoleError = console.error;
console.error = (...args) => {
  const errorMessage = args.join(' ');
  if (errorMessage.includes("Cannot read properties of null (reading 'options')")) {
    console.error('🚨 CAUGHT THE NULL OPTIONS ERROR! 🚨');
    console.error('Error message:', errorMessage);
    console.error('Stack trace:', new Error().stack);
    console.error('Arguments:', args);
  }
  originalConsoleError.apply(console, args);
};

// Global Error Boundary Component
class GlobalErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Global Error Boundary caught an error:', error);
    console.error('Error info:', errorInfo);
    console.error('Error stack:', error.stack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong.</h1>
          <p>Error: {this.state.error?.message}</p>
          <button onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

initializeIcons();

registerIcons({
  icons: {
    endpointsolid: <EndPointSolidIcon />,
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider>
      <DndProvider backend={HTML5Backend}>
        <BrowserRouter>
          <CustomerThemeProvider>
            <ModalContextProvider>
              <GlobalErrorBoundary>
                <Routes>
                  <Route path="/">
                    <Route index element={<HomePage />} />
                    <Route path="login" element={<LoginPage />} />
                    <Route path="signup" element={<SignUpPage />} />
                    <Route path="imprint" element={<ImprintPage />} />
                    <Route path="legal" element={<LegalPage />} />
                    <Route path="press" element={<PressPage />} />
                    <Route path="support" element={<SupportPage />} />
                    <Route path="markup/*" element={<MarkupPage></MarkupPage>} />
                    <Route path="din276/*" element={<TestDIN276></TestDIN276>} />
                    <Route path="editor" element={<EditorTest />} />
                    <Route element={<Protected />}>
                      <Route path="chatbot" element={<ChatBotPage />} />                    
                      <Route path="map-and-image" element={<MapAndImageView />} />
                      <Route path="entity" element={<EntityPage />} />
                      <Route path="settings" element={<SettingsPage />} />
                      <Route path="administration" element={<AdministrationPage />} />
                      <Route path="private/markup/*" element={<MarkupPage></MarkupPage>} />
                    </Route>
                  </Route>
                </Routes>
              </GlobalErrorBoundary>
            </ModalContextProvider>
          </CustomerThemeProvider>
        </BrowserRouter>
      </DndProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
